// @flow

import { connect } from 'react-redux';
import NetworkErrorModal from './networkerror';
import { closeNetworkErrorModal, runRetryFunction } from '../../../services/ui';

export type Props = {
  networkErrorModalIsOpen: boolean,
  closeNetworkErrorModal: Function,
};

const mapState = ({ ui }) => ({
  networkErrorModalIsOpen: ui.networkErrorModalIsOpen,
  isServerError: ui.isServerError,
});

const mapDispatch = {
  closeNetworkErrorModal,
  runRetryFunction,
};

export default connect(
  mapState,
  mapDispatch,
)(NetworkErrorModal);
